import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, catchError, throwError} from 'rxjs';
import {AdxBookingSegmentModel} from '../models/adx-booking-segment-model';
import {UpdateAdxBookingSegment} from '../models/update-adx-booking-segment-request';

@Injectable({
  providedIn: 'root'
})

export class AdxBookingSegmentService {
  private resourcePath: string = 'dbov2/adx-booking-segment';
  
  constructor(private httpClient: HttpClient) {
  }  
  
  getAdxBookingSegmentById(id: number): Observable<AdxBookingSegmentModel> {
      return this.httpClient
        .get<AdxBookingSegmentModel>(`${this.resourcePath}/${id}`)
        .pipe(catchError(this.errorHandler));
  }

  addAdxBookingSegment(data: AdxBookingSegmentModel): Observable<AdxBookingSegmentModel> {
    return this.httpClient.post<AdxBookingSegmentModel>(`${this.resourcePath}`, data)
      .pipe(catchError(this.errorHandler));
  }

  updateAdxBookingSegment(data: UpdateAdxBookingSegment): Observable<AdxBookingSegmentModel> {
    return this.httpClient.put<AdxBookingSegmentModel>(`${this.resourcePath}`, data)
      .pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(() => new Error(error.message || 'Server Error'));
  }
}
